import React from 'react';
import PropTypes from 'prop-types';

const TitleBanner = ({ title, subTitle }) => (
  <div className="banner">
    <div className="textContainer">
      <h1 className="title">{title}</h1>
      { subTitle && <h2 className="subTitle">{subTitle}</h2> }
    </div>
  </div>
);

TitleBanner.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
};

TitleBanner.defaultProps = {
  subTitle: null,
};

export default TitleBanner;



// WEBPACK FOOTER //
// src/components/molecules/TitleBanner/index.js